module.exports = __webpack_public_path__ + "img/resumeClass.dda2a0be.svg";